import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check authentication status
  const isAuthenticated = authService.isAuthenticated();

  if (isAuthenticated) {
    // User is authenticated, allow access
    return true;
  }

  // User is not authenticated
  // Define public routes that don't require authentication
  const publicRoutes = [
    '/login',
    '/signup',
    '/reset-password',
    '/auth/callback',
    '/auth/verify-email',
  ];
  const isPublicRoute = publicRoutes.some(
    (publicRoute) => state.url === publicRoute || state.url.startsWith(publicRoute),
  );

  // If trying to access a protected route, redirect to login
  if (!isPublicRoute) {
    // Only add returnUrl if there's a token (session expired scenario)
    // For first-time visitors (no token), don't add returnUrl
    const hasToken = !!authService.getToken();
    const queryParams = hasToken ? { returnUrl: state.url } : {};

    router.navigate(['/login'], {
      queryParams,
      replaceUrl: true,
    });
  }

  // Return false to prevent access to protected routes
  return false;
};
